<template>
  <div v-show="parentContainer.pageCount > 1" class="carousel-pagination">
    <ul class="carousel-dot-container">
      <li
        v-for="(page, index) in parentContainer.pageCount"
        :key="index"
        class="carousel-dot"
        :class="{ 'carousel-dot--active': index === parentContainer.currentPage }"
        @click="parentContainer.goToPage(index, 'pagination')"
      >
        <button
          class="carousel-dot-inner"
          :title="`Go to slide ${index}`"
          :aria-label="`ariaLabel ${index}`"
        ></button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return { parentContainer: this.$parent };
  },
};
</script>
